import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const SaintHelena: Country = {
    identifier: "SaintHelena",
    name: "Saint Helena",
    countryCode: "SH",
    group: CountryGroup.AFRICA,
    isUNMember: false,
    flag: "🇸🇭",
    svgPath: "m 434.58175,485.2254 -0.096,0.004 -0.028,-0.023 -0.018,-0.066 0.046,-0.107 0.042,-0.065 0.065,0.009 0.088,0.075 0.074,0.064 -0.04,0.058 -0.133,0.051 z m 24.339,22.892 -0.253,0.018 0.021,-0.137 0.188,-0.146 0.127,0.019 0.008,0.168 -0.091,0.078 z",
}
